import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] mb-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyValue = _resolveComponent("CopyValue")!
  const _component_CutValue = _resolveComponent("CutValue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CopyValue),
    _createVNode(_component_CutValue)
  ]))
}